import { render, staticRenderFns } from "./SetSeal.vue?vue&type=template&id=37b947ac&scoped=true&"
import script from "./SetSeal.vue?vue&type=script&lang=js&"
export * from "./SetSeal.vue?vue&type=script&lang=js&"
import style0 from "./SetSeal.vue?vue&type=style&index=0&id=37b947ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b947ac",
  null
  
)

export default component.exports